import http from "./httpService";
import { apiUrl } from "../config.json";

const apiEndpoint = apiUrl + "/forms";

export function sendMail(formData) {
  return http.post(apiEndpoint + "/", formData);
}
